import 'core-js/stable'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from 'vant'
import 'vant/lib/index.css'
import '@/styles/compat-legacy.css'
import VueLuckyCanvas from '@lucky-canvas/vue'
import { registerServiceWorker } from '@/utils/registerServiceWorker'
import { consumeTokenFromUrl } from '@/utils/tokenLogin'
import { getToken, removeUserInfo } from '@/utils/auth'
import { clearApiCache } from '@/utils/apiCache'
import { syncSupportAccessToken } from '@/api/support'

async function initApp() {
   const usedAdminLoginLink = consumeTokenFromUrl()
   const token = getToken()
   if (token) {
      store.commit('user/SET_TOKEN', token)
      syncSupportAccessToken(token)
      if (usedAdminLoginLink) {
         clearApiCache()
         removeUserInfo()
         store.commit('user/SET_USER_INFO', null)
      }
   }

   const app = createApp(App)

   try {
      app.use(router)
         .use(store)
         .use(vant)
         .use(VueLuckyCanvas)

      app.mount('#app')

      store.dispatch('config/bootstrapWebViewConfig')

      registerServiceWorker()
   } catch (error) {
      console.error('应用初始化失败:', error)
   }
}

initApp()
